import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Wheat, Lock, User } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login, token } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (token) return <Navigate to="/" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(username.trim(), password);
      toast.success("Autentificare reușită");
      navigate("/", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Credențiale invalide");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center pattern-bg px-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl border border-neutral-200 shadow-sm overflow-hidden">
          <div className="px-8 pt-10 pb-2 flex flex-col items-center">
            <div className="w-14 h-14 rounded-xl bg-amber-50 flex items-center justify-center mb-4">
              <Wheat className="w-7 h-7 text-amber-600" strokeWidth={1.75} />
            </div>
            <h1 className="text-2xl font-bold tracking-tight text-neutral-900 text-center">Brutăria LaDenis</h1>
            <p className="text-sm text-neutral-500 mt-1 text-center">SC AXA OMEGA · Raport producție</p>
          </div>

          <form onSubmit={onSubmit} className="px-8 pb-8 pt-6 space-y-4" data-testid="login-form">
            <div>
              <label className="text-xs font-semibold tracking-wider uppercase text-neutral-500 mb-1.5 block">Utilizator</label>
              <div className="relative">
                <User className="w-4 h-4 text-neutral-400 absolute left-3 top-1/2 -translate-y-1/2" />
                <input
                  data-testid="login-username-input"
                  type="text"
                  autoFocus
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="w-full rounded-md border border-neutral-300 pl-9 pr-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-colors"
                  placeholder="admin"
                  required
                />
              </div>
            </div>
            <div>
              <label className="text-xs font-semibold tracking-wider uppercase text-neutral-500 mb-1.5 block">Parolă</label>
              <div className="relative">
                <Lock className="w-4 h-4 text-neutral-400 absolute left-3 top-1/2 -translate-y-1/2" />
                <input
                  data-testid="login-password-input"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full rounded-md border border-neutral-300 pl-9 pr-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-colors"
                  placeholder="••••••••"
                  required
                />
              </div>
            </div>
            <button
              data-testid="login-submit-button"
              type="submit"
              disabled={submitting}
              className="w-full inline-flex items-center justify-center rounded-md bg-amber-600 hover:bg-amber-700 disabled:opacity-60 disabled:cursor-not-allowed px-4 py-2.5 text-sm font-semibold text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2 transition-colors"
            >
              {submitting ? "Se autentifică..." : "Autentificare"}
            </button>
          </form>
        </div>
        <p className="text-center text-xs text-neutral-400 mt-6">© Brutăria LaDenis · SC AXA OMEGA</p>
      </div>
    </div>
  );
}
